import { useAppSelector } from "@/config/store";
import { Avatar, Card, List, ListItem, ListItemIcon, ListItemText } from "@/components/ui";
import { IEdoCourse } from "@/shared/model/edo-course.model";
import { IEdoStudent } from "@/shared/model/edo-student.model";
import { EntityState } from "@/shared/reducers/reducer.utils";
import axios from "axios";
import { useEffect, useState } from "react";
import { translate } from "react-jhipster";

const CourseStudents = () => {
  const { entity: course } = useAppSelector<EntityState<IEdoCourse>>(
    (state) => state.edoCourse
  );
  const [students, setStudents] = useState<IEdoStudent[]>([]);

  useEffect(() => {
    const getStudents = async () => {
      const response = await axios.get<{ data: IEdoStudent[] }>(
        `/classes/${course.class.id}/students`
      );
      setStudents(response.data.data);
    };
    if (course.class?.id) {
      getStudents();
    }
  }, [course.class?.id]);

  return (
    <Card className="surface grid h-full grid-rows-[min-content_auto_min-content] overflow-hidden rounded-3xl p-0">
      <div className="border-b border-[var(--color-mockup-border)] bg-[var(--color-surface-secondary)]/50 dark:border-[var(--color-mockup-border)] dark:bg-[var(--color-surface-secondary)]/30">
        <div className="flex flex-wrap items-center justify-between gap-3 p-4">
          <h2 className="font-heading text-heading-3 font-bold text-[var(--color-mockup-text)]">
            {translate("edocendoApp.edoStudent.home.title")}
          </h2>
        </div>
      </div>
      {students && students.length > 0 ? (
        <List className="divide-y">
          {students.map((student) => (
            <ListItem key={student.userId} className="flex items-center gap-3 py-3">
              <ListItemIcon>
                <Avatar
                  alt={student.user.firstName + " " + student.user.lastName}
                  fallback={
                    (student.user.firstName?.[0] ?? "") +
                    (student.user.lastName?.[0] ?? "")
                  }
                  className="bg-primary/10 text-primary"
                />
              </ListItemIcon>
              <ListItemText
                primary={student.user.firstName + " " + student.user.lastName}
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <div className="p-4 text-center">
          <p className="text-body text-[var(--color-mockup-text-mid)]">
            Nessun studente trovato.
          </p>
        </div>
      )}
    </Card>
  );
};

export default CourseStudents;
